var _defs, _text, _defs2, _text2, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 50,
    viewBox: "0 0 220 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "smartGradient",
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4A90E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1D62F0"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 35,
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 30,
    fontWeight: "bold",
    fill: "url(#smartGradient)"
  }, "\n    Smart\n  ")), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "verifyGradient",
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00897B"
  })))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 35,
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 30,
    fontWeight: "bold",
    fill: "url(#verifyGradient)"
  }, "\n    Verify\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 25,
    r: 6,
    fill: "#00D3AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 25 L195 28 L202 18",
    stroke: "white",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b82167ade8632c46c7dec50402f4f24e.svg";
export { ForwardRef as ReactComponent };